<span>
  <div [class]="'job-count-wrapper'">
    <span>{{ jobCount }}</span>
  </div>
</span>
